import React from 'react';
import PropTypes from 'prop-types';

const TabLayout = props => (
  <div className="ansible-host-detail">{props.children}</div>
);

TabLayout.propTypes = {
  children: PropTypes.object.isRequired,
};

export default TabLayout;



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_ansible-12.0.6/webpack/components/AnsibleHostDetail/components/TabLayout.js